import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const Who = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Container
          sx={{
            backgroundImage: themeMode === 'dark' ? 'url(/images/logos/logo_white.PNG)' : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '20vh',
          }}
        ></Container>
        <Box
          component={Typography}
          fontWeight={700}
          variant={'h3'}
          gutterBottom
          align={'center'}
          color={theme.palette.primary.main}
        >
          La Dosis Positiva: Inspiración diaria para una vida en equilibrio
        </Box>
        <Typography
          variant={'h6'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
        >
          El espacio dedicado a optimizar el bienestar físico, la claridad mental y la calidad de nuestras relaciones. Transformamos hábitos cotidianos en herramientas de éxito, creando una plataforma de confianza donde las marcas se integran de forma natural en el estilo de vida de nuestra audiencia.
        </Typography>
        <Typography
          variant={'h5'}
          component={'p'}
          color={theme.palette.primary.main}
          align={'center'}
          sx={{ mt: 3, mb: 2, fontStyle: 'italic' }}
        >
          ¿Qué es La Dosis Positiva?
        </Typography>
        <Typography align="center" sx={{ mb: 1 }}>
          <Link
            href="https://tnonetwork.com/show/ladosispositiva"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            tnonetwork.com/show/ladosispositiva
          </Link>
        </Typography>
        <Typography
          variant={'body1'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
          sx={{ mt: 1 }}
        >
          Es un ecosistema de contenido diseñado para quienes buscan crecer personal y profesionalmente. Nos enfocamos en soluciones prácticas para la vida moderna: desde la mejora de la productividad y la salud, hasta la gestión efectiva de vínculos y acuerdos. En <strong>La Dosis Positiva</strong>, convertimos el bienestar en un lenguaje cercano, dinámico y, sobre todo, accionable. Transmisión en vivo los <strong>jueves a las 2:00 PM</strong> por TNO Network.
        </Typography>
      </Box>

      {/* Sección Yanira Bocaranda */}
      <Box marginTop={6} marginBottom={4}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={3}>
            <Box display="flex" justifyContent="center">
              <Box
                component="img"
                src="/images/yanirabocarandacandid.jpeg"
                alt="Yanira Bocaranda - Nuestra ancla, La Dosis Positiva"
                sx={{
                  width: { xs: 200, sm: 250, md: 300 },
                  height: { xs: 200, sm: 250, md: 300 },
                  borderRadius: 2,
                  objectFit: 'cover',
                  boxShadow: 3,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={9}>
            <Typography
              variant={'h5'}
              fontWeight={700}
              gutterBottom
              color={theme.palette.primary.main}
            >
              NUESTRA ANCLA: YANIRA BOCARANDA
            </Typography>
            <Typography
              variant={'body2'}
              color={'textSecondary'}
              sx={{ fontStyle: 'italic', mb: 2 }}
            >
              El carisma que conecta con el bienestar y la productividad
            </Typography>
            <Typography
              variant={'body1'}
              color={'textSecondary'}
            >
              <strong>Yanira Bocaranda</strong> lidera <strong>La Dosis Positiva</strong>, un espacio que combina bienestar físico, claridad mental y relaciones de calidad. Su estilo cercano y profesional convierte cada programa en una experiencia inspiradora, ofreciendo contenido práctico y una plataforma ideal para marcas que buscan integrarse de forma natural en el estilo de vida de la audiencia.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

Who.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default Who;
